module.exports = __webpack_public_path__ + "static/media/f4.edd53cf3.jpeg";